export const TAB_SCROLL_LIST_SCROLL_STEP = 200
